import LogService from "../CommonSdk/LogService";
import * as ErrorUtils from "../Utils/ErrorUtils";
import SandBoxServerFetch from "../Request/SandBoxServerFetch";
import RainbowServerFetch from "../Request/RainbowServerFetch";

const LOG_TAG = "SERVICE:ADMIN";

export const createUser = (userData) => {//Create user on sandbox
    LogService.trace(LOG_TAG, "createUser");

    let bodyParameters = {
        format: "full",
        loginEmail: userData.email,
        password: userData.password,
        firstName: userData.firstName,
        lastName: userData.lastName
    };

    const body = JSON.stringify(bodyParameters);

    return SandBoxServerFetch.post("/api/rainbow/admin/v1.0/users", body)
        .then(response => {
            LogService.info(LOG_TAG, "createUser", "success");
            return Promise.resolve(response.data);
        })
        .catch(error => {
            LogService.error(LOG_TAG, "createUser", "error", error);
            return Promise.reject(ErrorUtils.parseErrorAndReturnPayload(error));
        });
}

export const updateUser = (userId, criteria) => {//update user
    LogService.trace(LOG_TAG, "createUser");

    let bodyParameters = {
        format: "full",
        ...criteria
    };

    const body = JSON.stringify(bodyParameters);

    return RainbowServerFetch.put("/api/rainbow/admin/v1.0/users/" + userId, body)
        .then(response => {
            LogService.info(LOG_TAG, "createUser", "success");
            return Promise.resolve(response.data);
        })
        .catch(error => {
            LogService.error(LOG_TAG, "createUser", "error", error);
            return Promise.reject(ErrorUtils.parseErrorAndReturnPayload(error));
        });
}